export function formatStudyName(studyName: string): string {
  return studyName.toLowerCase().replace(/[^a-z0-9-_]/, '');
}

export function formatParticipantId(participantId: string): string {
  return participantId.replace(/[^A-Za-z0-9-_]/, '');
}
